import { memo } from "react";
import { useUser } from "../../../../../../../contexts/userContext/userContext";
import { CircularProgressbar } from "react-circular-progressbar";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";

import "./styles.scss";
import Tooltip from "../../../../../../Elements/Tooltip/Tooltip";

interface DaysLeftBarI {
  daysLeft: number;
  color: "green" | "orange" | "red" | undefined;
}

const ONE_MONTH_DAYS = 30;

const DaysLeftBar = memo((props: DaysLeftBarI) => {
  const { daysLeft, color } = props;
  const { getUserData } = useUser();
  const { getTextByKey } = useContent();

  if (getUserData().IsSubUser && getUserData().subUserRole !== "Admin")
    return null;

  return (
    <>
      {daysLeft! < 30 && daysLeft > -1 ? (
        <div className="userSubscriptionDaysLeft">
          {/*@ts-ignore*/}
          <Tooltip tooltipText={`${daysLeft} ${getTextByKey("days-left")}`}>
            <CircularProgressbar
              value={(daysLeft! / ONE_MONTH_DAYS) * 100}
              text={daysLeft + getTextByKey("d")}
              className={color}
            />
          </Tooltip>
        </div>
      ) : null}
    </>
  );
});

export default DaysLeftBar;
